import { CarPark } from "../../services";
import { createModelStore } from "../../utils";

const carParks = createModelStore<CarPark.Model, "carParks">("carParks");

export default carParks;
